<header class="header-main">
  <ng-content select="app-header">
  </ng-content>
</header>
<ng-content>
</ng-content>
